// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#emergency-transport-patient-setting[data-v-f537181a]{max-width:820px;margin-left:auto;margin-right:auto}#emergency-transport-patient-setting .box-header .title[data-v-f537181a]{font-size:22px;font-weight:700}#emergency-transport-patient-setting .cancel-btn[data-v-f537181a],#emergency-transport-patient-setting .update-btn[data-v-f537181a]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
